class RVCalculator extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.wrapper = this.closest('.rv-calculator-wrapper');
        this.paymentDisplay = this.querySelector('.rv-payment-amount');
        this.resultsCard = this.querySelector('.rv-results-card');
        this.inputs = {
            price: this.querySelector('[name="rv_price"]'),
            priceSlider: this.querySelector('[name="rv_price_slider"]'),
            downPayment: this.querySelector('[name="down_payment"]'),
            downPaymentSlider: this.querySelector('[name="down_payment_slider"]'),
            downPaymentPercent: this.querySelector('[name="down_payment_percent"]'),
            tradeIn: this.querySelector('[name="trade_in"]'),
            taxRate: this.querySelector('[name="sales_tax_rate"]'),
            term: this.querySelector('[name="loan_term"]'),
            interestRate: this.querySelector('[name="interest_rate"]')
        };
        this.bindEvents();
        this.initToggles();
        this.calculate();
    }
    bindEvents() {
        this.form.addEventListener('input', (e) => {
            const node = e.target;
            if (node === this.inputs.price) {
                this.inputs.priceSlider.value = node.value;
                this.updateDownPaymentPercent();
            } else if (node === this.inputs.priceSlider) {
                this.inputs.price.value = node.value;
                this.updateDownPaymentPercent();
            } else if (node === this.inputs.downPayment) {
                this.inputs.downPaymentSlider.value = node.value;
                this.updateDownPaymentPercent();
            } else if (node === this.inputs.downPaymentSlider) {
                this.inputs.downPayment.value = node.value;
                this.updateDownPaymentPercent();
            } else if (node === this.inputs.downPaymentPercent) {
                this.updateDownPaymentAmount();
            }
            this.calculate();
        });
        this.form.addEventListener('submit', (e) => e.preventDefault());
    }
    updateDownPaymentPercent() {
        const price = parseFloat(this.inputs.price.value) || 0;
        const amount = parseFloat(this.inputs.downPayment.value) || 0;
        if (price > 0) {
            this.inputs.downPaymentPercent.value = ((amount / price) * 100).toFixed(0);
        }
    }
    updateDownPaymentAmount() {
        const price = parseFloat(this.inputs.price.value) || 0;
        const percent = parseFloat(this.inputs.downPaymentPercent.value) || 0;
        const amount = ((percent / 100) * price).toFixed(0);
        this.inputs.downPayment.value = amount;
        this.inputs.downPaymentSlider.value = amount;
    }
    initToggles() {
        const blockParent = this.closest('.bi_weekly_payment_par_block, .bi_weekly_tabs, .bi_weekly_pdf_plan');
        if (blockParent) {
            const btns = blockParent.querySelectorAll('[data-rv-calculator-toggle]');
            btns.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.toggle();
                });
            });
        }
        const closeBtn = this.querySelector('.rv-calculator-close');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => this.toggle(false));
        }
    }
    toggle(forceState) {
        if (!this.wrapper || this.wrapper.classList.contains('standalone-mode')) return;
        const isOpen = this.wrapper.classList.contains('open');
        const nextState = forceState !== undefined ? forceState : !isOpen;
        if (nextState) {
            this.wrapper.classList.add('open');
            setTimeout(() => {
                const rect = this.wrapper.getBoundingClientRect();
                if (rect.top < 0 || rect.bottom > window.innerHeight) {
                    this.wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 400);
        } else {
            this.wrapper.classList.remove('open');
        }
    }
    calculate() {
        const price = parseFloat(this.inputs.price.value) || 0;
        const downPayment = parseFloat(this.inputs.downPayment.value) || 0;
        const tradeIn = parseFloat(this.inputs.tradeIn.value) || 0;
        const taxRate = (parseFloat(this.inputs.taxRate.value) || 0) / 100;
        const termMonths = parseInt(this.inputs.term.value) || 240;
        const annualInterestRate = (parseFloat(this.inputs.interestRate?.value) || 7.99) / 100;
        const salesTax = price * taxRate;
        const principal = (price + salesTax) - (downPayment + tradeIn);
        if (principal <= 0) {
            this.paymentDisplay.textContent = '$0';
            return;
        }
        const monthlyInterestRate = annualInterestRate / 12;
        const x = Math.pow(1 + monthlyInterestRate, termMonths);
        const monthlyPayment = (principal * x * monthlyInterestRate) / (x - 1);
        if (!isNaN(monthlyPayment) && isFinite(monthlyPayment)) {
            this.paymentDisplay.textContent = this.formatCurrency(monthlyPayment);
        } else {
            this.paymentDisplay.textContent = '$0';
        }
    }
    formatCurrency(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    }
}
if (!customElements.get('rv-calculator')) {
    customElements.define('rv-calculator', RVCalculator);
}
